'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = IconCropSquare;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function IconCropSquare(props) {
  const size = props.size,
        style = props.style,
        rest = _objectWithoutProperties(props, ['size', 'style']);

  const baseStyles = {};

  if (size) {
    baseStyles['--_mt-iconSize'] = size;
  }

  const styleToApply = _extends({}, baseStyles, {
    width: 'var(--_mt-iconSize, 1em)',
    height: 'var(--_mt-iconSize, 1em)'
  }, style);

  return _react2.default.createElement(
    'svg',
    _extends({ xmlns: 'http://www.w3.org/2000/svg', style: styleToApply, viewBox: '0 0 48 48' }, rest),
    ' ',
    _react2.default.createElement('path', { d: 'M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z' })
  );
}


//////////////////
// WEBPACK FOOTER
// /Users/jamess/webdev/react-projects/materialish/docs/node_modules/materialish/icon-crop-square.js
// module id = 942
// module chunks = 0 1 2